import { Component } from 'preact';
import style from './MobileHeader.scss';
import { connect } from 'react-redux';
import RouteHelper from '../../../helpers/RouteHelper';
import { Link } from 'react-router-dom';
import Logo from '../../logo';
import {FOOTSHOP_LOGO_COLORS} from '../../logo/constants';

// eslint-disable-next-line react/prefer-stateless-function
class MobileHeader extends Component {
	render({ mutation, currency, mutations, location, route, suggestedShopId }) {
		const extraClass = route.name === '/register' ? ` ${style.register}` : '';
		return (
			<header className={style.header + extraClass}>
				<Link to={RouteHelper.getUrl('/')} className={style['logo-link']}>
					<Logo color={FOOTSHOP_LOGO_COLORS.WHITE}/>
				</Link>
				<a className={`go-to-shop ${style.hide} ${style['go-to-shop-mobile']}`} href={RouteHelper.getExternalUrlByShopId(suggestedShopId)}>
					Go to eshop <span className={'arrow'}/>
				</a>
			</header>
		);
	}
}

const mapStateToProps = (state) => {
	const { ui } = state;
	return {
		mutations: state.mutations,
		mutation: ui.mutation,
		currency: ui.currency,
		suggestedShopId: ui.suggestedShopId,
	};
};

export default connect(mapStateToProps)(MobileHeader);



// WEBPACK FOOTER //
// ./components/header/mobile/MobileHeader.js